<template>
    <div class="d-flex pb-3">
        <div class="ml-0 mr-auto">
            <div class="table-per-page">
                <div class="table-per-page__title">
                    Showing:
                </div>
                <div class="table-per-page__buttons">
                    <b-button v-for="(button, index) in getPerPageArray"
                        :key="index"
                        type="button"
                        size="sm"
                        class="mr-1"
                        @click="perPageAction(button.quantyti)"
                        :class="{'active': button.quantyti === setForRequest.perPage}"
                        variant="outline-user-primary">{{button.title}}</b-button>
                </div>
            </div>
        </div>
        <div class="mr-0 ml-auto">
            <b-pagination
                v-if="showPagination"
                v-model="setForRequest.page"
                :total-rows="settings.total"
                :per-page="getPerPageArray[perPageActive > 0 ? perPageActive -1 : 1].quantyti"
                :hide-goto-end-buttons="false"
                @change="changePage"
                class="my-0 pagination-user">
                <template slot="first-text">‹</template>
                <template slot="last-text">›</template>
            </b-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            settings: {
                type: Object,
                required: true
            },
            perPageArray: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                prevIconPagination: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                nextIconPagination: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
                setForRequest: {
                    page: this.settings.page,
                    perPage: +this.$route.query.perPage || this.perPageArray[0]
                }
            }
        },
        computed: {
            showPagination() {
                return this.settings && this.settings.pagesTotal ? (this.settings.pagesTotal > 1 && this.setForRequest.perPage !== this.settings.total) : false
            },
            perPageActive() {
                    return this.getPerPageArray.findIndex(item => {
                        return item.quantyti === this.settings.count || item.quantyti === Number(this.$route.query.perPage)
                    }) + 1
            },
            getPerPageArray() {
                let array = this.perPageArray.filter(item => item < this.settings.total)
                array = array.map((item, index) => {
                    item = {
                        title: item,
                        quantyti: item
                    }
                    return item
                })
                return array
            }
        },
        created() {},
        beforeUpdate() {},
        methods: {
            perPageAction(quantyti) {
                this.setForRequest.page = 1
                this.setForRequest.perPage = quantyti
                this.settings.page = 1
                this.$emit('paginateAction', this.setForRequest)
            },
            changePage(payload) {
                this.setForRequest.page = payload
                this.$emit('paginateAction', this.setForRequest)
            }
        }
    }
</script>

<style lang="scss">
    .pagination {
        .page-item {
            &:nth-last-child(2),
            &:nth-child(2) {
                display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/TablePagination.vue